import React, { FunctionComponent } from "react";

import NavBarLegacy from "./nav_bar_legacy";
import NavBarRedesign from "./nav_bar_redesign";
import { useFlags } from "../../services/utilities/launch_darkly_helper";

// Top nav reskin. The reskinned top nav is built as a parallel component tree
// (nav_bar_redesign) and swapped in here behind the shared Explorer-reskin feature flag,
// mirroring the project_portfolio_page.tsx redesign/legacy pattern. When the flag is off the
// existing nav (nav_bar_legacy) renders unchanged.
//
// `newDesignExplorerView` is the shared Explorer-reskin LaunchDarkly flag (LD key
// `new-design-explorer-view`, camelCased by the LD SDK). This switch is the only place the top
// nav reads it.
export const NavBar: FunctionComponent = () => {
  const { newDesignExplorerView } = useFlags();
  return newDesignExplorerView ? <NavBarRedesign/> : <NavBarLegacy/>;
};

export default NavBar;
